import { D19 } from "./SalesSummaryPerProductGroup/D19"

export const DistrictPerformanceByProductGroup = {
  "sections": [
    D19
  ]
}